import type { I18nConfig } from '@vantage-hub/brand-kit'
import i18n from 'i18next'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

let initialized = false

export async function initI18n(config: I18nConfig): Promise<void> {
  if (initialized) return
  initialized = true

  const localesPath = config.localesPath ?? '/locales'

  await i18n
    .use(HttpBackend)
    .use(initReactI18next)
    .init({
      lng: config.defaultLocale,
      fallbackLng: config.defaultLocale,
      supportedLngs: config.supportedLocales,
      ns: ['common', 'errors'],
      defaultNS: 'common',
      backend: {
        loadPath: `${localesPath}/{{lng}}/{{ns}}.json`,
      },
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: true,
      },
    })
}

export { i18n }
